var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GiveWise Document Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "3.03318889e-05 1.20975761e-05 64.1381512 1.20975761e-05 64.1381512 85.4976157 3.03318889e-05 85.4976157"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home3",
    transform: "translate(-1200.000000, -266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1200.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7650383,21.299541 L46.6538925,21.299541 C45.3549027,20.0110641 44.0385758,18.7058034 42.7650383,17.44241 L42.7650383,21.299541 Z M58.7991947,69.4582549 L58.7991947,68.7232735 C58.7991947,51.7471387 58.8020199,34.7711883 58.7793342,17.7950535 C58.7787808,17.4208308 58.5784823,16.9540208 58.3138152,16.6871405 C54.7008788,13.0445097 51.0549282,9.4345243 47.4338765,5.80000878 C47.0961724,5.46101358 46.7566239,5.35459248 46.2979291,5.35459248 C36.493627,5.3649219 26.6895094,5.36233978 16.8852073,5.36233978 L16.136762,5.36233978 L16.136762,8.04534482 L17.0567338,8.04534482 C24.5598154,8.04534482 32.062897,8.05954647 39.5657941,8.02985211 C40.6777648,8.02542562 41.5239617,8.36183871 42.3087412,9.15547112 C46.4886369,13.3838738 50.6919561,17.5892218 54.9194366,21.7698553 C55.7460832,22.5872801 56.1118218,23.4639091 56.109793,24.6343463 C56.0834185,39.2607538 56.0926404,53.8871612 56.0926404,68.5135686 L56.0926404,69.4582549 L58.7991947,69.4582549 Z M5.44070706,13.4061907 L5.44070706,80.1275665 L50.7238637,80.1275665 L50.7238637,26.7570318 L49.9062545,26.7570318 C46.7894537,26.7570318 43.6728372,26.7607205 40.5560364,26.7557407 C38.4453393,26.7522364 37.4132299,25.7225246 37.4110166,23.6230783 C37.4073279,20.4815629 37.4100945,17.3400474 37.4100945,14.198532 L37.4100945,13.4061907 L5.44070706,13.4061907 Z M56.0926404,74.8229739 L56.0926404,76.8112048 C56.0924559,78.7778565 56.1005712,80.7443238 56.0896894,82.7106067 C56.080652,84.3249837 55.0232746,85.4129776 53.4109264,85.4928388 C53.2434576,85.5011385 53.0752511,85.4961587 52.9074134,85.4961587 C36.3409132,85.4963431 19.774413,85.499663 3.2077283,85.4830636 C2.62546069,85.4823259 1.99321066,85.3945339 1.47162282,85.1558724 C0.494844471,84.7089816 0.071561556,83.824975 0.007193043,82.7692576 C-0.005717547,82.5542041 0.002766555,82.337675 0.002766555,82.1218838 C0.002582118,58.5484375 0.002397681,34.9749912 0.006639732,11.4013605 C0.006639732,10.9963368 0.027849987,10.5843046 0.102178098,10.1872117 C0.340470702,8.91219872 1.32020005,8.0676617 2.62103421,8.05548886 C5.0181619,8.03335642 7.4158429,8.04682032 9.81333946,8.04534482 C10.0721046,8.04516038 10.3310541,8.04534482 10.6960549,8.04534482 C10.6960549,7.69989432 10.6942106,7.4221322 10.6964238,7.14418564 C10.7087811,5.5862463 10.6621185,4.02480266 10.753046,2.47128981 C10.8354893,1.05794908 11.8843825,0.118611435 13.2964322,0.0197532027 C13.5113013,0.0048138057 13.7276459,0.0109002267 13.9432528,0.0109002267 C25.1634777,0.0105313527 36.3837026,0.0171710847 47.6039274,1.2097576e-05 C48.6788263,-0.0016414893 49.5252077,0.322229883 50.2915434,1.09612753 C54.4922805,5.33891628 58.712568,9.56233915 62.9555411,13.7628918 C63.7823722,14.5816077 64.1392578,15.4820291 64.1381538,16.6399246 C64.1202608,34.9371816 64.1281916,53.2346231 64.1136211,71.5318801 C64.1130678,72.1183897 64.0492526,72.7565418 63.8142798,73.2803428 C63.3096602,74.4048552 62.3133315,74.8262938 61.1148599,74.8238961 C59.4667309,74.8207607 57.8184174,74.8229739 56.0926404,74.8229739 L56.0926404,74.8229739 Z",
    id: "Fill-1",
    fill: "#293860",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 13.4007353,
    y1: 34.425,
    x2: 42.4892647,
    y2: 34.425,
    id: "Line-9",
    stroke: "#51BEED",
    strokeWidth: 2.673,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.4007353,
    y1: 43.335,
    x2: 42.4892647,
    y2: 43.335,
    id: "Line-9",
    stroke: "#51BEED",
    strokeWidth: 2.673,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.4007353,
    y1: 52.245,
    x2: 42.4892647,
    y2: 52.245,
    id: "Line-9",
    stroke: "#51BEED",
    strokeWidth: 2.673,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.4007353,
    y1: 61.155,
    x2: 42.4892647,
    y2: 61.155,
    id: "Line-9",
    stroke: "#51BEED",
    strokeWidth: 2.673,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.6e55d10ead0e311a5b8151f3fb73e169.svg";
export { ForwardRef as ReactComponent };